import React, { useEffect, useState } from "react";
import AdminSideBar from "./AdminSideBar";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { hideNavUserAction } from "../store/actions/showNavUserAction";
import { getUppercaseText } from "../share/common";

import { Column } from "@ant-design/charts";
import axios from "axios";
// {type, sales}

const CONFIG = {
  data: [],
  xField: "name",
  yField: "stock",
  label: {
    position: "middle",
    style: {
      fill: "#FFFFFF",
      opacity: 0.6,
    },
  },
  xAxis: {
    label: {
      autoHide: true,
      autoRotate: false,
    },
  },
  meta: {
    name: {
      alias: "Vino",
    },
    stock: {
      alias: "Stock",
    },
  },
  tooltip: {
    formatter: (data) => ({
      name: "Stock",
      value: data.stock,
      title: data.fullName,
    }),
    fields: ["stock", "fullName", "name"],
  },
};

function Admin() {
  const user = useSelector((state) => state.user_auth);
  const [products, setProducts] = useState([]);
  const [config, setConfig] = useState(CONFIG);

  const dispatch = useDispatch();

  useEffect(() => {
    const data = products.map((p) => ({
      name: getUppercaseText(p.name),
      stock: p.stock,
      fullName: p.name,
    }));
    setConfig({ ...CONFIG, data });
  }, [products]);

  useEffect(() => {
    const productsURL = process.env.REACT_APP_API_URL + `/products`;
    const fetchAllProducts = async () => {
      try {
        const productsData = await axios({
          method: "GET",
          url: productsURL,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        });
        setProducts(productsData.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchAllProducts();
    dispatch(hideNavUserAction());
  }, []);
  return (
    <div id="twc-admin">
      <div className="container">
        <Row className="mt-6 mb-5">
          <Col sm={2} className="d-flex flex-column">
            <AdminSideBar />
          </Col>
          <Col lg={10}>
            <div className="shadow p-4 border border-dark rounded admin-table">
              <Row>
                <h5>Stock</h5>
                <Column {...config} />
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Admin;
